import * as React from 'react';
import {CourseContext} from '../../context/CourseContext';
import {DirectUpload} from '../../components/media/DirectUpload';
import { MediaPreviewComponent } from '../media/MediaPreview';

export function CourseFeaturedComponent(){
  const {values, setUploadCoverUrl, setUploadPosterUrl} = React.useContext(CourseContext);

  return(
    <div>
      <div className="flow-text">Imagens para divlugar seu curso</div>
      <div className="card">
        <div className="card-content">
          <div className="row">
            <div className="col s12">
              <div className="col l7 s12">
                <div className="flow-text">Capa</div>
                <DirectUpload 
                  mediaType='image'
                  folder='courses/covers'
                  onUploadComplete={setUploadCoverUrl}
                >
                  <MediaPreviewComponent
                    mediaType='image'
                    file={values.cover}
                    removeAll={() => setUploadCoverUrl('')}
                    isUploading={false}
                    uploadProgress={0}
                  />
                </DirectUpload>
              </div>
              <div className="col l5 s12">
                <div className="flow-text">Poster</div>
                <div style={{ aspectRatio: '2/3', maxWidth: '100%', margin: '0 auto' }}>
                  <DirectUpload 
                    mediaType='image'
                    folder='courses/posters'
                    onUploadComplete={setUploadPosterUrl}
                    customMessage='Clique ou arraste sua imagem aqui'
                  >
                    <MediaPreviewComponent
                      mediaType='image'
                      file={values.poster}
                      removeAll={() => setUploadPosterUrl('')}
                      isUploading={false}
                      uploadProgress={0}
                    />
              </DirectUpload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}